export const getResultNumber = (index: number) => {
  return ({
    pluralResults: index > 0,
    resultNumber:   index + 1,
  });
};